import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import PageMeta from '../../components/common/PageMeta';
import PublicNavbar from '../../components/common/PublicNavbar';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const HERO_ROLES = ['Financial Analyst', 'Product Manager', 'Software Engineer', 'Data Analyst', 'HR Manager', 'Marketing Manager'];

// ── SVG Icons ──────────────────────────────────────────────────────────────────
function IconTarget({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>;
}
function IconPen({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4 9.5-9.5z"/></svg>;
}
function IconMic({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="2" width="6" height="11" rx="3"/><path d="M19 10v2a7 7 0 01-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>;
}
function IconSparkle({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
}
function IconTrendUp({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>;
}
function IconCheckSquare({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>;
}
function IconCheck({ className = 'w-3.5 h-3.5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
}
function IconArrow({ className = 'w-4 h-4' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>;
}
function IconQuote({ className = 'w-4 h-4' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor"><path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/></svg>;
}
function IconStar({ className = 'w-4 h-4' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
}
function IconShield({ className = 'w-4 h-4' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
}
function IconBook({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>;
}
function IconBriefcase({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>;
}
function IconZap({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
}
function IconAward({ className = 'w-5 h-5' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>;
}
function IconX({ className = 'w-4 h-4' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
}
function IconMinus({ className = 'w-4 h-4' }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>;
}

// ── Data ──────────────────────────────────────────────────────────────────────
const ROLES = [
  { title: 'Financial Analyst',  category: 'Finance',    slug: 'financial-analyst'  },
  { title: 'HR Manager',         category: 'HR',         slug: 'hr-manager'         },
  { title: 'Software Engineer',  category: 'Technology', slug: 'software-engineer'  },
  { title: 'Marketing Manager',  category: 'Marketing',  slug: 'marketing-manager'  },
  { title: 'Data Analyst',       category: 'Technology', slug: 'data-analyst'       },
  { title: 'Product Manager',    category: 'Technology', slug: 'product-manager'    },
  { title: 'Accountant',         category: 'Finance',    slug: 'accountant'         },
  { title: 'Operations Manager', category: 'Operations', slug: 'operations-manager' },
];

const STEPS = [
  { num: '01', title: 'Choose your role', body: 'Browse 150+ job roles across 15 industries. Each role has 1,000 questions refined by AI and industry experts.', icon: <IconTarget className="w-6 h-6" /> },
  { num: '02', title: 'Study the material', body: 'Work through Beginner, Intermediate, and Advanced study guides for your role before you practice — so you walk in knowing the content.', icon: <IconBook className="w-6 h-6" /> },
  { num: '03', title: 'Practice all three formats', body: 'Multiple choice for quick recall. Written answers for depth. Spoken answers to train your delivery — just like a real interview.', icon: <IconPen className="w-6 h-6" /> },
  { num: '04', title: 'Get AI feedback & your plan', body: 'Every answer is scored by Claude. After each session you get a personalised improvement plan and a completion certificate.', icon: <IconSparkle className="w-6 h-6" /> },
];

const TESTIMONIALS = [
  { name: 'Sarah Al Mansouri', role: 'Financial Analyst, ADCB',          initials: 'SA', color: '#1B3A5C', text: 'I practiced the Financial Analyst track for two weeks. The AI feedback on my written answers was more specific than anything I got from my university career centre.' },
  { name: 'James Okonkwo',     role: 'HR Business Partner, Noon',         initials: 'JO', color: '#7C3AED', text: 'The spoken answer feature is what sets this apart. Knowing your filler words and hesitation patterns before the real interview is genuinely useful.' },
  { name: 'Priya Sharma',      role: 'Data Analyst, Careem',              initials: 'PS', color: '#059669', text: 'Finished the Data Analyst track in three weeks. The certificate is a nice bonus but the real win was walking into interviews actually prepared.' },
  { name: 'Omar Al Rashidi',   role: 'Operations Manager candidate',      initials: 'OR', color: '#C1272D', text: 'Used JD Prep before my Amazon interview. It generated questions so specific to their job description that my interviewer asked three of them almost word for word.' },
];

const STATS = [
  { value: '150+',  label: 'Job roles' },
  { value: '1,000', label: 'Questions per role' },
  { value: '3',     label: 'Answer formats' },
  { value: '100%',  label: 'AI-evaluated' },
];

const COMPANIES = ['Goldman Sachs', 'Noon', 'ADCB', 'Careem', 'Talabat', 'Majid Al Futtaim'];

const COMPARE = [
  { label: 'Role-specific questions (150+ roles)',     ip: true,  gpt: 'partial', boards: 'partial', video: false   },
  { label: 'MCQ practice with instant scoring',        ip: true,  gpt: false,     boards: false,     video: false   },
  { label: 'Written answer AI scoring (0–10)',         ip: true,  gpt: 'partial', boards: false,     video: false   },
  { label: 'Spoken / voice interview practice',        ip: true,  gpt: false,     boards: false,     video: false   },
  { label: 'Job description tailored questions',       ip: true,  gpt: 'partial', boards: false,     video: false   },
  { label: 'Structured study guides (3 levels)',       ip: true,  gpt: false,     boards: false,     video: 'partial'},
  { label: 'Personalised end-of-session plan',         ip: true,  gpt: false,     boards: false,     video: false   },
  { label: 'Digital completion certificate',           ip: true,  gpt: false,     boards: false,     video: 'partial'},
  { label: 'Structured 25-question sessions',          ip: true,  gpt: false,     boards: false,     video: false   },
  { label: 'Starting price',                           ip: 'Free',gpt: '$20/mo',  boards: 'Free',    video: 'Free'  },
];

// ── Helpers ───────────────────────────────────────────────────────────────────
function useIntersection(ref, threshold = 0.12) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref, threshold]);
  return visible;
}

function FadeIn({ children, delay = 0 }) {
  const ref = useRef();
  const visible = useIntersection(ref);
  return (
    <div ref={ref} style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)', transition: `opacity 0.55s ease ${delay}s, transform 0.55s ease ${delay}s` }}>
      {children}
    </div>
  );
}

function CompareCell({ v }) {
  if (v === true)      return <div style={{ display:'flex', justifyContent:'center' }}><span style={{ width:22, height:22, borderRadius:'50%', background:'#D1FAE5', display:'flex', alignItems:'center', justifyContent:'center' }}><IconCheck className="w-3 h-3" style={{ color:'#059669' }} /></span></div>;
  if (v === false)     return <div style={{ display:'flex', justifyContent:'center' }}><span style={{ width:22, height:22, borderRadius:'50%', background:'#FEE2E2', display:'flex', alignItems:'center', justifyContent:'center' }}><IconX className="w-3 h-3" style={{ color:'#DC2626' }} /></span></div>;
  if (v === 'partial') return <div style={{ display:'flex', justifyContent:'center' }}><span style={{ fontSize:11, fontWeight:700, padding:'2px 8px', borderRadius:99, background:'#FEF3C7', color:'#D97706' }}>Partial</span></div>;
  return <div style={{ textAlign:'center', fontSize:12, fontWeight:700, color:'#64748B' }}>{v}</div>;
}

// ── Product Mockup ────────────────────────────────────────────────────────────
function ProductMockup() {
  return (
    <div className="relative">
      <div className="absolute inset-0 rounded-3xl pointer-events-none" style={{ background: 'radial-gradient(ellipse at center, rgba(193,39,45,0.25) 0%, rgba(27,58,92,0.15) 40%, transparent 70%)', transform: 'scale(0.88) translateY(28px)', filter: 'blur(20px)' }} />
      <div className="relative rounded-2xl overflow-hidden" style={{ boxShadow: '0 32px 80px rgba(0,0,0,0.40), 0 0 0 1px rgba(255,255,255,0.08)' }}>
        <div style={{ background: '#0a1929' }} className="px-5 py-3 flex items-center gap-2.5">
          <div className="flex gap-1.5">
            {[1,2,3].map(i => <div key={i} className="w-3 h-3 rounded-full" style={{ background: 'rgba(255,255,255,0.1)' }} />)}
          </div>
          <div className="flex-1 mx-3 rounded-md h-5 flex items-center px-3" style={{ background: 'rgba(255,255,255,0.07)' }}>
            <span className="text-[11px] font-mono" style={{ color: 'rgba(255,255,255,0.3)' }}>centricq.com/practice</span>
          </div>
        </div>
        <div style={{ background: '#1B3A5C' }} className="px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-[11px] font-bold uppercase tracking-wider" style={{ color: '#C1272D' }}>Financial Analyst</span>
            <span style={{ color: 'rgba(255,255,255,0.2)' }}>·</span>
            <span className="text-[11px]" style={{ color: 'rgba(255,255,255,0.45)' }}>Written Answer</span>
          </div>
          <span className="text-[11px] font-semibold" style={{ color: 'rgba(255,255,255,0.45)' }}>7 / 25</span>
        </div>
        <div className="h-[3px]" style={{ background: 'rgba(255,255,255,0.1)' }}>
          <div className="h-full rounded-full" style={{ width: '28%', background: '#C1272D' }} />
        </div>
        <div className="p-5 bg-white">
          <p className="text-[11px] font-bold uppercase tracking-wider mb-2" style={{ color: '#64748B' }}>Question 7</p>
          <p className="text-[13px] font-medium leading-[1.65] mb-4 italic" style={{ color: '#0F172A' }}>
            "Walk me through how you would analyse a company's liquidity position using its financial statements."
          </p>
          <div className="flex items-center gap-3 p-3 rounded-xl mb-3.5" style={{ background: '#F0F6FF' }}>
            <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: '#DBEAFE' }}>
              <span className="text-[17px] font-extrabold" style={{ color: '#2563EB' }}>7</span>
            </div>
            <div>
              <p className="text-[13px] font-bold" style={{ color: '#0F172A' }}>Score: 7 / 10 — Good</p>
              <p className="text-[11px] mt-0.5" style={{ color: '#64748B' }}>Strong on ratios, missed cash cycle</p>
            </div>
          </div>
          <div className="p-3 rounded-xl" style={{ background: '#EFF6FF' }}>
            <p className="text-[10px] font-bold uppercase tracking-wider mb-1" style={{ color: '#2563EB' }}>Study tip</p>
            <p className="text-[12px] leading-[1.6]" style={{ color: '#1e40af' }}>Review the cash conversion cycle and how days payable, receivable, and inventory affect liquidity.</p>
          </div>
        </div>
        <div className="border-t px-5 py-3 flex items-center justify-between" style={{ borderColor: '#E2E8F0', background: '#F8FAFC' }}>
          <div className="flex gap-1">
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={i} className="h-1.5 rounded-full" style={{ width: i < 7 ? 7 : 5, background: i < 7 ? '#C1272D' : '#E2E8F0' }} />
            ))}
          </div>
          <div className="text-white text-[12px] font-semibold px-3 py-1.5 rounded-lg" style={{ background: '#C1272D' }}>Next</div>
        </div>
      </div>
      <div className="absolute -top-5 -right-5 bg-white rounded-2xl border px-4 py-3" style={{ borderColor: '#E2E8F0', boxShadow: '0 8px 28px rgba(0,0,0,0.12)' }}>
        <p className="text-[10px] font-medium mb-0.5" style={{ color: '#64748B' }}>Session score</p>
        <p className="text-[20px] font-extrabold leading-none" style={{ color: '#0F172A' }}>74<span className="text-[13px] font-normal" style={{ color: '#64748B' }}>/100</span></p>
        <p className="text-[10px] font-semibold mt-1" style={{ color: '#059669' }}>+8 from last session</p>
      </div>
      <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl border px-4 py-3 flex items-center gap-2.5" style={{ borderColor: '#E2E8F0', boxShadow: '0 8px 28px rgba(0,0,0,0.12)' }}>
        <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: '#EDE9FE' }}>
          <IconSparkle className="w-4 h-4" style={{ color: '#7C3AED' }} />
        </div>
        <div>
          <p className="text-[10px] font-medium" style={{ color: '#64748B' }}>Powered by</p>
          <p className="text-[13px] font-bold" style={{ color: '#0F172A' }}>Claude AI</p>
        </div>
      </div>
    </div>
  );
}

// ── JD Prep Mockup ────────────────────────────────────────────────────────────
function JDPrepMockup() {
  const chapters = [
    { label: 'Technical Skills',      done: true  },
    { label: 'Core Responsibilities', done: true  },
    { label: 'Behavioural',           done: true  },
    { label: 'Situational',           done: false, active: true },
    { label: 'Culture & Fit',         done: false },
  ];
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 20, overflow: 'hidden', boxShadow: '0 24px 64px rgba(0,0,0,0.35)' }}>
        {/* Header */}
        <div style={{ padding: '13px 18px', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(0,0,0,0.15)' }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#C1272D', display: 'inline-block', flexShrink: 0 }} />
          <span style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.7)' }}>JD Prep — Generating questions…</span>
        </div>
        {/* Role + progress */}
        <div style={{ padding: '16px 18px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <div>
              <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#fff' }}>Senior Financial Analyst</p>
              <p style={{ margin: '2px 0 0', fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>JP Morgan · Jun 2025</p>
            </div>
            <span style={{ fontSize: 18, fontWeight: 800, color: '#C1272D' }}>87%</span>
          </div>
          <div style={{ height: 6, background: 'rgba(255,255,255,0.08)', borderRadius: 99, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: '87%', background: 'linear-gradient(90deg, #C1272D, #e05a5f)', borderRadius: 99 }} />
          </div>
        </div>
        {/* Chapters */}
        <div style={{ padding: '8px 18px 14px' }}>
          {chapters.map((c, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderBottom: i < 4 ? '1px solid rgba(255,255,255,0.05)' : 'none' }}>
              <div style={{ width: 20, height: 20, borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: c.done ? '#059669' : c.active ? 'rgba(193,39,45,0.3)' : 'rgba(255,255,255,0.07)', border: c.active ? '1.5px solid #C1272D' : 'none' }}>
                {c.done && <IconCheck className="w-3 h-3" style={{ color: '#fff' }} />}
                {c.active && <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#C1272D', display: 'block' }} />}
              </div>
              <span style={{ flex: 1, fontSize: 13, fontWeight: c.active ? 700 : 400, color: c.done ? 'rgba(255,255,255,0.55)' : c.active ? '#fff' : 'rgba(255,255,255,0.22)' }}>{c.label}</span>
              <span style={{ fontSize: 11, fontWeight: 600, color: c.done ? '#059669' : c.active ? '#C1272D' : 'rgba(255,255,255,0.18)' }}>
                {c.done ? '25 Qs ✓' : c.active ? 'Writing…' : '25 Qs'}
              </span>
            </div>
          ))}
        </div>
      </div>
      {/* Badge */}
      <div style={{ position: 'absolute', top: -14, right: -14, background: '#C1272D', color: '#fff', padding: '7px 14px', borderRadius: 12, fontSize: 12, fontWeight: 800, boxShadow: '0 4px 16px rgba(193,39,45,0.40)' }}>
        1 free session
      </div>
      {/* Floating total */}
      <div style={{ position: 'absolute', bottom: -16, left: -16, background: '#fff', borderRadius: 14, padding: '10px 16px', boxShadow: '0 8px 28px rgba(0,0,0,0.18)' }}>
        <p style={{ margin: 0, fontSize: 11, color: '#64748B', fontWeight: 500 }}>Total questions</p>
        <p style={{ margin: '2px 0 0', fontSize: 22, fontWeight: 800, color: '#0F172A', lineHeight: 1 }}>125 <span style={{ fontSize: 12, color: '#64748B', fontWeight: 400 }}>in 90 seconds</span></p>
      </div>
    </div>
  );
}

// ── Page ──────────────────────────────────────────────────────────────────────
export default function HomePage() {
  const [roleIdx, setRoleIdx] = useState(0);
  const [roleVis, setRoleVis] = useState(true);
  const [prices, setPrices] = useState({ starter: 10, fa: 19.99 });

  useEffect(() => {
    const t = setInterval(() => {
      setRoleVis(false);
      setTimeout(() => { setRoleIdx(i => (i + 1) % HERO_ROLES.length); setRoleVis(true); }, 260);
    }, 2800);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    fetch(`${API_BASE}/system/pricing`)
      .then(r => r.json())
      .then(d => setPrices({ starter: +(d.starter_monthly_price_usd ?? 10), fa: +(d.monthly_price_usd ?? 19.99) }))
      .catch(() => {});
  }, []);

  const fmt = n => Number.isInteger(n) ? `${n}` : n.toFixed(2);

  return (
    <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif", color: '#0F172A', overflowX: 'hidden', background: '#040D18' }}>
      <PageMeta
        title="AI-Powered Interview Preparation"
        description="The complete interview preparation platform. 1,000 role-specific questions, structured study courses, JD-tailored prep, ATS CV scanning, and AI feedback on every answer. 100 questions free (Chapter 1) — no credit card needed."
        path="/"
      />
      <style>{`
        *, *::before, *::after { box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        @media (prefers-reduced-motion: reduce) { *, *::before, *::after { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; } }
      `}</style>

      <PublicNavbar forceLight={false} />

      {/* ── HERO ──────────────────────────────────────────────────────────── */}
      <section className="relative min-h-screen flex items-center overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #0A1929 0%, #0d2238 45%, #1B3A5C 100%)' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px)', backgroundSize: '64px 64px' }} />
        <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[800px] h-[800px] pointer-events-none" style={{ background: 'radial-gradient(ellipse at center right, rgba(193,39,45,0.12) 0%, transparent 60%)' }} />

        <div className="relative z-[1] w-full max-w-7xl mx-auto px-6 lg:px-10 py-24">
          {/* Social proof logos */}
          <div className="flex flex-wrap items-center gap-2 mb-8">
            <span className="text-[12px] font-semibold" style={{ color: 'rgba(255,255,255,0.40)' }}>Trusted by candidates at</span>
            {COMPANIES.map(c => (
              <span key={c} className="text-[12px] font-bold px-3 py-1 rounded-full border" style={{ color: 'rgba(255,255,255,0.65)', borderColor: 'rgba(255,255,255,0.12)', background: 'rgba(255,255,255,0.05)' }}>{c}</span>
            ))}
          </div>

          <div className="grid lg:grid-cols-2 gap-14 xl:gap-20 items-center">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 mb-7 border" style={{ background: 'rgba(193,39,45,0.1)', borderColor: 'rgba(193,39,45,0.3)' }}>
                <span className="w-1.5 h-1.5 rounded-full flex-shrink-0 animate-pulse" style={{ background: '#C1272D' }} />
                <span className="text-[13px] font-semibold" style={{ color: 'rgba(255,255,255,0.75)' }}>The complete interview preparation platform</span>
              </div>

              <h1 className="font-extrabold text-white tracking-[-0.03em] leading-[1.05] mb-6" style={{ fontSize: 'clamp(44px, 5.5vw, 76px)' }}>
                Ace your<br />
                <span style={{ color: '#C1272D', display: 'inline-block', transition: 'opacity 0.26s ease, transform 0.26s ease', opacity: roleVis ? 1 : 0, transform: roleVis ? 'translateY(0)' : 'translateY(8px)' }}>
                  {HERO_ROLES[roleIdx]}
                </span>
                <br />interview.
              </h1>

              <p className="leading-[1.65] mb-6 max-w-[500px]" style={{ fontSize: 'clamp(16px, 1.5vw, 18px)', color: 'rgba(255,255,255,0.60)' }}>
                1,000 role-specific questions. Structured study guides. JD-tailored prep. AI feedback on every single answer.
              </p>

              {/* 3 pillars */}
              <div className="flex flex-wrap gap-3 mb-10">
                {[
                  { icon: <IconCheckSquare className="w-3.5 h-3.5" />, label: 'Practice — MCQ · Written · Spoken' },
                  { icon: <IconBook className="w-3.5 h-3.5" />,        label: 'Study Guides — Beginner to Advanced'  },
                  { icon: <IconBriefcase className="w-3.5 h-3.5" />,   label: 'JD Prep — 125 tailored questions' },
                ].map(({ icon, label }) => (
                  <span key={label} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-semibold" style={{ background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.65)', border: '1px solid rgba(255,255,255,0.10)' }}>
                    {icon} {label}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-3 mb-10">
                <Link to="/roles" className="inline-flex items-center justify-center gap-2 text-white no-underline px-7 py-4 rounded-xl text-[15px] font-bold transition-all duration-200"
                  style={{ background: '#C1272D' }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#A8202B'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#C1272D'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                  Start for free <IconArrow className="w-4 h-4" />
                </Link>
                <Link to="/roles/financial-analyst" className="inline-flex items-center justify-center gap-2 text-white no-underline px-7 py-4 rounded-xl text-[15px] font-semibold border transition-all duration-200"
                  style={{ background: 'rgba(255,255,255,0.06)', borderColor: 'rgba(255,255,255,0.15)' }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.12)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                  Try free — Financial Analyst
                </Link>
              </div>

              <p className="text-[13px] mb-10 flex items-center gap-1.5" style={{ color: 'rgba(255,255,255,0.35)' }}>
                <IconShield className="w-3.5 h-3.5" />
                100 questions free (Chapter 1) · No credit card · No account needed
              </p>

              <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
                {STATS.map(({ value, label }) => (
                  <div key={label}>
                    <p className="font-extrabold text-white leading-none mb-1" style={{ fontSize: 'clamp(24px, 2.5vw, 32px)' }}>{value}</p>
                    <p className="text-[13px] font-medium" style={{ color: 'rgba(255,255,255,0.40)' }}>{label}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="hidden lg:block relative pl-4 pt-12 pb-12">
              <ProductMockup />
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none" style={{ background: 'linear-gradient(transparent, #FFFFFF)' }} />
      </section>

      {/* ── STAT BAR ──────────────────────────────────────────────────────── */}
      <section style={{ background: '#FFFFFF', borderBottom: '1px solid #E2E8F0' }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {[
            { icon: <IconStar className="w-3.5 h-3.5" style={{ color: '#D97706' }} />,        text: '4.9 / 5 rating' },
            { icon: <IconCheckSquare className="w-3.5 h-3.5" style={{ color: '#059669' }} />, text: '10,000+ sessions completed' },
            { icon: <IconTarget className="w-3.5 h-3.5" style={{ color: '#1B3A5C' }} />,      text: '150+ job roles' },
            { icon: <IconBook className="w-3.5 h-3.5" style={{ color: '#0891B2' }} />,        text: '15+ industries' },
            { icon: <IconBriefcase className="w-3.5 h-3.5" style={{ color: '#C1272D' }} />,   text: 'JD Prep — 1 free session' },
            { icon: <IconSparkle className="w-3.5 h-3.5" style={{ color: '#7C3AED' }} />,     text: 'Powered by Claude AI' },
          ].map(({ icon, text }) => (
            <div key={text} className="flex items-center gap-2">
              {icon}
              <span className="text-[13px] font-semibold" style={{ color: '#334155' }}>{text}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── HOW IT WORKS ──────────────────────────────────────────────────── */}
      <section style={{ background: '#FFFFFF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="mb-3" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2563EB' }}>How it works</p>
              <h2 className="font-extrabold tracking-[-0.025em] leading-[1.1]" style={{ fontSize: 'clamp(28px, 4vw, 44px)', color: '#0F172A' }}>From zero to interview-ready</h2>
              <p className="mt-3 max-w-md mx-auto" style={{ fontSize: 16, color: '#64748B', lineHeight: 1.65 }}>Four steps. Study, practice, speak, improve. One platform.</p>
            </div>
          </FadeIn>
          <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            <div className="hidden lg:block absolute top-[42px] left-[calc(12.5%+24px)] right-[calc(12.5%+24px)] h-[2px] pointer-events-none"
              style={{ background: 'linear-gradient(90deg, #E2E8F0, #1B3A5C, #C1272D, #E2E8F0)', zIndex: 0 }} />
            {STEPS.map((step, i) => (
              <FadeIn key={step.num} delay={i * 0.08}>
                <div className="group relative bg-white border rounded-[20px] p-7 h-full transition-all duration-200"
                  style={{ borderColor: '#E2E8F0', boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.10)'; e.currentTarget.style.borderColor = '#1B3A5C'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)'; e.currentTarget.style.borderColor = '#E2E8F0'; }}>
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: '#EFF6FF', color: '#2563EB', zIndex: 1 }}>{step.icon}</div>
                    <span className="text-[13px] font-bold" style={{ color: '#CBD5E1' }}>{step.num}</span>
                  </div>
                  <h3 className="font-bold mb-2.5 leading-[1.3]" style={{ fontSize: 17, color: '#0F172A' }}>{step.title}</h3>
                  <p style={{ fontSize: 14, color: '#64748B', lineHeight: 1.75 }}>{step.body}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── THREE WAYS TO PRACTISE ────────────────────────────────────────── */}
      <section style={{ background: '#F0F6FF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="mb-3" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2563EB' }}>Three ways to practise</p>
              <h2 className="font-extrabold tracking-[-0.025em] leading-[1.1]" style={{ fontSize: 'clamp(28px, 4vw, 44px)', color: '#0F172A' }}>Built like a real interview</h2>
              <p className="mt-3 max-w-lg mx-auto" style={{ fontSize: 15, color: '#64748B', lineHeight: 1.65 }}>Every session combines all three formats — escalating challenge that mirrors an actual interview.</p>
            </div>
          </FadeIn>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              { type: 'Multiple choice', icon: <IconCheckSquare className="w-7 h-7" />, iconBg: '#DBEAFE', iconColor: '#2563EB', tag: 'Instant results', tagBg: '#EFF6FF', tagColor: '#2563EB', desc: 'Test your knowledge fast. 10 MCQs per session covering key concepts, terminology, and common scenarios. Instant right/wrong feedback with explanation.', demo: '"Which ratio best measures a firm\'s short-term liquidity?" · Quick ratio · Current ratio · Debt ratio' },
              { type: 'Written answer',  icon: <IconPen className="w-7 h-7" />,          iconBg: '#EDE9FE', iconColor: '#7C3AED', tag: 'AI scored',      tagBg: '#EDE9FE', tagColor: '#7C3AED', desc: "Type your answer just like you'd write in an assessment. Claude reads it, gives a score out of 10, specific feedback, and what a model answer looks like.", demo: 'Score 8/10 · "Strong STAR structure. Add more quantified outcomes to elevate your answer."' },
              { type: 'Spoken answer',   icon: <IconMic className="w-7 h-7" />,           iconBg: '#FEF3C7', iconColor: '#D97706', tag: 'Voice + AI',    tagBg: '#FEF3C7', tagColor: '#D97706', desc: 'Record your voice. Whisper transcribes it. Claude evaluates your content accuracy, communication clarity, and confidence indicators like filler words.', demo: '"2 filler words detected · Pacing: good · Content accuracy: 7/10"' },
            ].map((item, i) => (
              <FadeIn key={item.type} delay={i * 0.08}>
                <div className="bg-white rounded-[20px] p-8 border h-full transition-all duration-200 flex flex-col"
                  style={{ borderColor: '#E2E8F0', boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)' }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.10)'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.borderColor = '#CBD5E1'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = '#E2E8F0'; }}>
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ background: item.iconBg, color: item.iconColor }}>{item.icon}</div>
                    <span className="text-[11px] font-bold px-3 py-1 rounded-full" style={{ background: item.tagBg, color: item.tagColor }}>{item.tag}</span>
                  </div>
                  <h3 className="font-bold mb-3 leading-tight" style={{ fontSize: 20, color: '#0F172A' }}>{item.type}</h3>
                  <p className="mb-5 flex-1" style={{ fontSize: 14, color: '#64748B', lineHeight: 1.75 }}>{item.desc}</p>
                  <div className="rounded-xl p-3 border" style={{ background: '#F8FAFC', borderColor: '#E2E8F0' }}>
                    <p className="text-[10px] font-bold uppercase tracking-wider mb-1.5" style={{ color: '#94A3B8' }}>Example</p>
                    <p className="text-[12px]" style={{ color: '#334155', lineHeight: 1.6 }}>{item.demo}</p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── AI FEEDBACK ───────────────────────────────────────────────────── */}
      <section style={{ background: '#FFFFFF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <FadeIn>
              <div>
                <p className="mb-4" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2563EB' }}>AI feedback</p>
                <h2 className="font-extrabold tracking-[-0.025em] mb-5 leading-[1.1]" style={{ fontSize: 'clamp(28px, 4vw, 40px)', color: '#0F172A' }}>
                  Not just right or wrong.<br />Actually useful.
                </h2>
                <p className="leading-[1.8] mb-8" style={{ fontSize: 15, color: '#64748B' }}>
                  For every written and spoken answer, Claude reads what you said, scores it out of 10, and tells you exactly what you got right, what you missed, and what to study next.
                </p>
                <div className="flex flex-col gap-3.5">
                  {['Score out of 10 with full reasoning', 'Specific feedback on your answer', 'Model answer summary', 'Personalised study recommendation'].map(label => (
                    <div key={label} className="flex gap-3 items-center">
                      <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: '#D1FAE5' }}>
                        <IconCheck className="w-3 h-3" style={{ color: '#059669' }} />
                      </div>
                      <span className="font-medium" style={{ fontSize: 15, color: '#334155' }}>{label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </FadeIn>
            <FadeIn delay={0.12}>
              <div className="bg-white border rounded-[20px] overflow-hidden" style={{ borderColor: '#E2E8F0', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
                <div className="px-5 py-4 flex items-center gap-3" style={{ background: '#1B3A5C' }}>
                  <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: '#EDE9FE' }}><IconSparkle className="w-3.5 h-3.5" style={{ color: '#7C3AED' }} /></div>
                  <span className="font-semibold text-white" style={{ fontSize: 14 }}>AI Feedback</span>
                  <span className="ml-auto font-medium" style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>Powered by Claude</span>
                </div>
                <div className="px-6 pt-6 pb-5">
                  <p className="font-bold uppercase tracking-wider mb-1.5" style={{ fontSize: 11, color: '#64748B' }}>Question</p>
                  <p className="mb-5 leading-[1.65] italic" style={{ fontSize: 13, color: '#0F172A' }}>"Walk me through how you would analyse a company's liquidity position using its financial statements."</p>
                  <div className="flex items-center gap-3.5 mb-5 p-3.5 rounded-xl" style={{ background: '#F0F6FF' }}>
                    <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: '#DBEAFE' }}>
                      <span className="font-extrabold" style={{ fontSize: 19, color: '#2563EB' }}>7</span>
                    </div>
                    <div>
                      <p className="font-bold" style={{ fontSize: 15, color: '#0F172A' }}>Score: 7/10</p>
                      <p className="mt-0.5 font-semibold" style={{ fontSize: 12, color: '#059669' }}>Good answer</p>
                    </div>
                  </div>
                  <p className="leading-[1.7] mb-4" style={{ fontSize: 13, color: '#334155' }}>Good coverage of current ratio and quick ratio. You correctly identified industry benchmarks. However, you missed the cash ratio and didn't discuss working capital cycle.</p>
                  <div className="py-3.5 px-4 rounded-xl" style={{ background: '#EFF6FF' }}>
                    <p className="mb-1 font-bold uppercase tracking-wider" style={{ fontSize: 10, color: '#2563EB' }}>Study tip</p>
                    <p className="leading-[1.65]" style={{ fontSize: 13, color: '#1e40af' }}>Review the cash conversion cycle and how days payable, receivable, and inventory outstanding interact to affect liquidity.</p>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* ── JD PREP ───────────────────────────────────────────────────────── */}
      <section style={{ background: 'linear-gradient(135deg, #0d2238 0%, #1B3A5C 100%)' }} className="py-24 px-6 lg:px-10 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)', backgroundSize: '48px 48px' }} />
        <div className="absolute top-0 right-0 w-[600px] h-[600px] pointer-events-none" style={{ background: 'radial-gradient(ellipse at top right, rgba(193,39,45,0.10) 0%, transparent 60%)' }} />
        <div className="relative max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <FadeIn>
              <div>
                <div className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 mb-7 border" style={{ background: 'rgba(193,39,45,0.12)', borderColor: 'rgba(193,39,45,0.30)' }}>
                  <IconBriefcase className="w-3.5 h-3.5" style={{ color: '#C1272D' }} />
                  <span className="text-[13px] font-semibold" style={{ color: 'rgba(255,255,255,0.75)' }}>JD Prep — New feature</span>
                </div>
                <h2 className="font-extrabold text-white tracking-[-0.025em] mb-5 leading-[1.1]" style={{ fontSize: 'clamp(28px, 4vw, 44px)' }}>
                  Paste any job description.<br />
                  <span style={{ color: '#C1272D' }}>Get 125 tailored questions.</span>
                </h2>
                <p className="leading-[1.8] mb-8" style={{ fontSize: 15, color: 'rgba(255,255,255,0.55)' }}>
                  Every job description is different. We generate 125 interview questions in 90 seconds — structured across 5 chapters specifically matched to the skills, responsibilities, and culture in that exact JD.
                </p>
                <div className="flex flex-col gap-3 mb-10">
                  {[
                    { icon: <IconZap className="w-4 h-4" />, text: '125 questions in 90 seconds', sub: 'Across 5 structured chapters' },
                    { icon: <IconSparkle className="w-4 h-4" />, text: 'Model answers + prep tips', sub: 'For every single question' },
                    { icon: <IconAward className="w-4 h-4" />, text: 'Downloadable as PDF', sub: 'Study anywhere, anytime' },
                  ].map(({ icon, text, sub }) => (
                    <div key={text} className="flex gap-3 items-start">
                      <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(193,39,45,0.18)', color: '#C1272D' }}>{icon}</div>
                      <div>
                        <p className="font-semibold text-white" style={{ fontSize: 14 }}>{text}</p>
                        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.40)' }}>{sub}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex flex-wrap gap-3">
                  <Link to="/interview-prep" className="inline-flex items-center gap-2 text-white no-underline px-6 py-3.5 rounded-xl font-bold transition-all duration-200"
                    style={{ background: '#C1272D', fontSize: 14 }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#A8202B'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = '#C1272D'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                    Try JD Prep free <IconArrow className="w-4 h-4" />
                  </Link>
                  <span className="inline-flex items-center gap-1.5 px-4 py-3.5 rounded-xl text-[13px] font-semibold" style={{ color: 'rgba(255,255,255,0.50)', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)' }}>
                    <IconCheck className="w-3 h-3" style={{ color: '#059669' }} /> First session free
                  </span>
                </div>
              </div>
            </FadeIn>
            <FadeIn delay={0.12}>
              <div className="relative pl-4 pt-10 pb-10">
                <JDPrepMockup />
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* ── ROLES PREVIEW ─────────────────────────────────────────────────── */}
      <section style={{ background: '#F0F6FF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="flex justify-between items-end mb-8 flex-wrap gap-4">
              <div>
                <p className="mb-2" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2563EB' }}>Job roles</p>
                <h2 className="font-extrabold tracking-[-0.025em]" style={{ fontSize: 'clamp(28px, 4vw, 40px)', color: '#0F172A' }}>Your role, 1,000 questions</h2>
                <p className="mt-2" style={{ fontSize: 14, color: '#64748B' }}>100 questions free (Chapter 1) per role. No account needed to start.</p>
              </div>
              <Link to="/roles" className="inline-flex items-center gap-1.5 no-underline font-semibold transition-all duration-200"
                style={{ fontSize: 14, color: '#1B3A5C' }}
                onMouseEnter={e => e.currentTarget.style.color = '#C1272D'}
                onMouseLeave={e => e.currentTarget.style.color = '#1B3A5C'}>
                Browse all 150+ roles <IconArrow className="w-4 h-4" />
              </Link>
            </div>
          </FadeIn>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {ROLES.map((role, i) => (
              <FadeIn key={role.slug} delay={i * 0.05}>
                <Link to={`/roles/${role.slug}`} className="block no-underline group relative bg-white border rounded-[20px] p-5 transition-all duration-200 overflow-hidden"
                  style={{ borderColor: '#E2E8F0', boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.10)'; e.currentTarget.style.borderColor = '#1B3A5C'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)'; e.currentTarget.style.borderColor = '#E2E8F0'; }}>
                  <p className="font-bold uppercase tracking-wider mb-1.5" style={{ fontSize: 11, color: '#C1272D' }}>{role.category}</p>
                  <p className="font-bold mb-4 leading-[1.3]" style={{ fontSize: 15, color: '#0F172A' }}>{role.title}</p>
                  <div className="flex gap-2 flex-wrap">
                    <span className="text-[11px] px-2 py-1 rounded-lg font-bold" style={{ background: '#D1FAE5', color: '#059669' }}>100 free</span>
                    <span className="text-[11px] px-2 py-1 rounded-lg font-medium" style={{ background: '#F0F6FF', color: '#64748B' }}>1,000 Qs</span>
                  </div>
                  <div className="absolute inset-x-0 bottom-0 flex items-center justify-center py-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200" style={{ background: 'linear-gradient(transparent, rgba(27,58,92,0.04))' }}>
                    <span className="text-[13px] font-bold" style={{ color: '#1B3A5C' }}>Start practising →</span>
                  </div>
                </Link>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── COURSES ───────────────────────────────────────────────────────── */}
      <section style={{ background: '#FFFFFF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="mb-3" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2563EB' }}>Study guides</p>
              <h2 className="font-extrabold tracking-[-0.025em] leading-[1.1]" style={{ fontSize: 'clamp(28px, 4vw, 44px)', color: '#0F172A' }}>
                Build the knowledge.<br />Then ace the interview.
              </h2>
              <p className="mt-4 max-w-xl mx-auto" style={{ fontSize: 16, color: '#64748B', lineHeight: 1.65 }}>
                Structured study materials for every role — from foundational concepts to advanced topics. Chapter 1 of every study guide is free.
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {[
              { level: 'Beginner', color: '#059669', bg: '#F0FDF4', border: '#86EFAC', num: '01', icon: <IconTarget className="w-6 h-6" />, desc: 'Core concepts, key terminology, and foundational theory. Ideal if you\'re switching roles or refreshing your knowledge before the interview.', topics: ['Fundamental concepts', 'Key definitions & terms', 'Industry overview', 'Common frameworks'] },
              { level: 'Intermediate', color: '#D97706', bg: '#FFFBEB', border: '#FCD34D', num: '02', icon: <IconTrendUp className="w-6 h-6" />, desc: 'Applied knowledge and scenario-based learning. Covers the kind of depth interviewers expect from a candidate with 1–3 years of experience.', topics: ['Applied case studies', 'Process & methodology', 'Tools & techniques', 'Problem-solving scenarios'] },
              { level: 'Advanced', color: '#1B3A5C', bg: '#EFF6FF', border: '#93C5FD', num: '03', icon: <IconSparkle className="w-6 h-6" />, desc: 'Strategic thinking, leadership scenarios, and complex problem frameworks. Designed for senior roles and candidates targeting competitive positions.', topics: ['Strategic frameworks', 'Leadership & stakeholders', 'Complex analysis', 'Cross-functional thinking'] },
            ].map((lv, i) => (
              <FadeIn key={lv.level} delay={i * 0.08}>
                <div className="border-2 rounded-[20px] p-7 h-full flex flex-col" style={{ borderColor: lv.border, background: lv.bg, boxShadow: `0 4px 24px ${lv.color}10` }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = `0 8px 32px ${lv.color}20`; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = `0 4px 24px ${lv.color}10`; }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
                    <div style={{ width: 48, height: 48, borderRadius: 12, background: `${lv.color}15`, color: lv.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{lv.icon}</div>
                    <span style={{ fontSize: 13, fontWeight: 700, color: lv.color, background: `${lv.color}15`, padding: '3px 10px', borderRadius: 99 }}>{lv.num}</span>
                  </div>
                  <h3 style={{ fontSize: 20, fontWeight: 800, color: '#0F172A', marginBottom: 8 }}>{lv.level}</h3>
                  <p style={{ fontSize: 14, color: '#64748B', lineHeight: 1.7, marginBottom: 20, flex: 1 }}>{lv.desc}</p>
                  <div className="space-y-2">
                    {lv.topics.map(t => (
                      <div key={t} className="flex items-center gap-2">
                        <div style={{ width: 16, height: 16, borderRadius: '50%', background: `${lv.color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <IconCheck className="w-2.5 h-2.5" style={{ color: lv.color }} />
                        </div>
                        <span style={{ fontSize: 13, color: '#334155' }}>{t}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>

          <FadeIn delay={0.2}>
            <div className="text-center">
              <Link to="/courses" className="inline-flex items-center gap-2 text-white no-underline px-7 py-3.5 rounded-xl font-bold transition-all duration-200"
                style={{ background: '#1B3A5C', fontSize: 15 }}
                onMouseEnter={e => { e.currentTarget.style.background = '#142d47'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#1B3A5C'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                Browse all study guides <IconArrow className="w-4 h-4" />
              </Link>
              <p className="mt-3" style={{ fontSize: 13, color: '#94A3B8' }}>Chapter 1 free · No account needed · Included in all paid plans</p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── AI TOOLS ──────────────────────────────────────────────────────── */}
      <section style={{ background: '#FFFFFF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="mb-3" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#C1272D' }}>AI Tools</p>
              <h2 className="font-extrabold tracking-[-0.025em] leading-[1.1]" style={{ fontSize: 'clamp(28px, 4vw, 44px)', color: '#0F172A' }}>
                Your complete interview toolkit
              </h2>
              <p className="mt-4 max-w-xl mx-auto" style={{ fontSize: 16, color: '#64748B', lineHeight: 1.65 }}>
                From any job description to salary negotiation — every AI tool you need to stand out, in one platform.
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5">
            <div className="lg:col-span-2">
              <FadeIn>
                <Link to="/interview-prep" className="block no-underline rounded-[24px] p-8 relative overflow-hidden h-full transition-all duration-200"
                  style={{ background: 'linear-gradient(135deg, #0d2238 0%, #1B3A5C 100%)', minHeight: 228, cursor: 'pointer' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 12px 48px rgba(27,58,92,0.40)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                  <div style={{ position: 'absolute', top: 0, right: 0, width: 260, height: 260, background: 'radial-gradient(ellipse at top right, rgba(193,39,45,0.18) 0%, transparent 60%)', pointerEvents: 'none' }} />
                  <div className="relative">
                    <span className="inline-flex items-center px-3 py-1.5 rounded-full mb-6 border" style={{ background: 'rgba(193,39,45,0.15)', borderColor: 'rgba(193,39,45,0.35)', fontSize: 11, fontWeight: 700, color: '#ff7b80', textTransform: 'uppercase', letterSpacing: '0.08em' }}>JD Prep</span>
                    <h3 style={{ fontSize: 'clamp(20px, 2.8vw, 28px)', fontWeight: 900, color: '#fff', lineHeight: 1.2, marginBottom: 10, letterSpacing: '-0.02em' }}>
                      Paste any job description.<br />
                      <span style={{ color: '#C1272D' }}>Get 125 tailored questions.</span>
                    </h3>
                    <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', lineHeight: 1.7, maxWidth: 400, marginBottom: 22 }}>
                      5 chapters · 25 questions each · generated in 90 seconds, matched to the exact skills and culture in that JD. First session free.
                    </p>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 700, color: '#C1272D' }}>
                      Try JD Prep free <IconArrow className="w-4 h-4" />
                    </span>
                  </div>
                </Link>
              </FadeIn>
            </div>

            <div>
              <FadeIn delay={0.08}>
                <Link to="/ats" className="block no-underline rounded-[24px] p-7 relative overflow-hidden h-full transition-all duration-200"
                  style={{ background: 'linear-gradient(135deg, #1E3A5F 0%, #0F172A 100%)', minHeight: 228, cursor: 'pointer' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 12px 48px rgba(15,23,42,0.45)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                  <span className="inline-flex items-center px-3 py-1.5 rounded-full mb-5 border" style={{ background: 'rgba(96,165,250,0.1)', borderColor: 'rgba(96,165,250,0.25)', fontSize: 11, fontWeight: 700, color: '#60A5FA', textTransform: 'uppercase', letterSpacing: '0.08em' }}>ATS CV Score</span>
                  <h3 style={{ fontSize: 22, fontWeight: 900, color: '#fff', lineHeight: 1.2, marginBottom: 10, letterSpacing: '-0.02em' }}>Beat the bots.<br />Land the interview.</h3>
                  <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.40)', lineHeight: 1.65, marginBottom: 18 }}>Upload your CV. Get a 0–100 score with keyword gaps and specific fixes.</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ flex: 1, height: 6, background: 'rgba(255,255,255,0.08)', borderRadius: 99, overflow: 'hidden' }}>
                      <div style={{ width: '78%', height: '100%', background: 'linear-gradient(90deg, #3B82F6, #60A5FA)', borderRadius: 99 }} />
                    </div>
                    <span style={{ fontSize: 15, fontWeight: 900, color: '#60A5FA' }}>78</span>
                  </div>
                </Link>
              </FadeIn>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { title: 'STAR Coach', desc: 'Master behavioural questions. Record your answer, get scored STAR-method feedback.', to: '/star-coach', accent: '#7C3AED', accentBg: '#EDE9FE', icon: <IconMic className="w-4 h-4" />, badge: 'Full Access' },
              { title: 'Cover Letter', desc: 'Upload your CV + a JD. Get a tailored, compelling cover letter in under 30 seconds.', to: '/cover-letter', accent: '#059669', accentBg: '#D1FAE5', icon: <IconPen className="w-4 h-4" />, badge: 'Full Access' },
              { title: 'Company Prep', desc: '10 tailored questions + culture brief for any company and role combination.', to: '/company-prep', accent: '#0891B2', accentBg: '#CFFAFE', icon: <IconBriefcase className="w-4 h-4" />, badge: 'Full Access' },
              { title: 'Salary Negotiation', desc: 'Counter-script + 3 CV-backed leverage points + live AI HR roleplay practice.', to: '/salary-neg', accent: '#D97706', accentBg: '#FEF3C7', icon: <IconTrendUp className="w-4 h-4" />, badge: 'Job Seeker' },
            ].map((tool, i) => (
              <FadeIn key={tool.title} delay={i * 0.06}>
                <Link to={tool.to} className="block no-underline bg-white border rounded-[20px] p-6 h-full transition-all duration-200"
                  style={{ borderColor: '#E2E8F0', boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)', cursor: 'pointer' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(0,0,0,0.10)'; e.currentTarget.style.borderColor = tool.accent; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)'; e.currentTarget.style.borderColor = '#E2E8F0'; }}>
                  <div style={{ width: 44, height: 44, borderRadius: 14, background: tool.accentBg, color: tool.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14, flexShrink: 0 }}>
                    {tool.icon}
                  </div>
                  <span style={{ fontSize: 10, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.12em', color: tool.accent, marginBottom: 6, display: 'block' }}>{tool.badge}</span>
                  <h3 style={{ fontSize: 15, fontWeight: 800, color: '#0F172A', marginBottom: 7, lineHeight: 1.25 }}>{tool.title}</h3>
                  <p style={{ fontSize: 13, color: '#64748B', lineHeight: 1.65 }}>{tool.desc}</p>
                </Link>
              </FadeIn>
            ))}
          </div>

          <FadeIn delay={0.24}>
            <div className="text-center mt-12">
              <Link to="/features" className="inline-flex items-center gap-2 no-underline font-semibold transition-colors" style={{ fontSize: 14, color: '#64748B', cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.color = '#1B3A5C'}
                onMouseLeave={e => e.currentTarget.style.color = '#64748B'}>
                See all AI tools on the features page <IconArrow className="w-4 h-4" />
              </Link>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── TESTIMONIALS ──────────────────────────────────────────────────── */}
      <section style={{ background: '#F0F6FF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="mb-3" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2563EB' }}>What candidates say</p>
              <h2 className="font-extrabold tracking-[-0.025em]" style={{ fontSize: 'clamp(28px, 4vw, 40px)', color: '#0F172A' }}>Used by candidates at top companies</h2>
              <div className="flex items-center justify-center gap-1 mt-4">
                {[1,2,3,4,5].map(n => <IconStar key={n} className="w-5 h-5" style={{ color: '#D97706' }} />)}
                <span className="ml-2 font-bold" style={{ fontSize: 15, color: '#334155' }}>4.9 / 5</span>
                <span className="ml-1" style={{ fontSize: 13, color: '#94A3B8' }}>from 400+ reviews</span>
              </div>
            </div>
          </FadeIn>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {TESTIMONIALS.map((t, i) => (
              <FadeIn key={i} delay={i * 0.08}>
                <div className="bg-white rounded-[20px] p-7 h-full border transition-all duration-200 flex flex-col"
                  style={{ borderColor: '#E2E8F0', boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#CBD5E1'; e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.10)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)'; }}>
                  <div className="flex gap-0.5 mb-5">{[1,2,3,4,5].map(n => <IconStar key={n} className="w-3.5 h-3.5" style={{ color: '#D97706' }} />)}</div>
                  <div className="w-9 h-9 rounded-xl flex items-center justify-center mb-5" style={{ background: '#EFF6FF' }}>
                    <IconQuote className="w-4 h-4" style={{ color: '#2563EB' }} />
                  </div>
                  <p className="leading-[1.8] mb-7 italic flex-1" style={{ fontSize: 15, color: '#334155' }}>"{t.text}"</p>
                  <div className="flex items-center gap-3 pt-5 border-t" style={{ borderColor: '#E2E8F0' }}>
                    <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-white text-[13px] flex-shrink-0" style={{ background: t.color }}>{t.initials}</div>
                    <div>
                      <p className="font-bold" style={{ fontSize: 14, color: '#0F172A' }}>{t.name}</p>
                      <p className="mt-0.5" style={{ fontSize: 12, color: '#94A3B8' }}>{t.role}</p>
                    </div>
                    <span className="ml-auto text-[11px] font-bold px-2 py-1 rounded-full" style={{ background: '#D1FAE5', color: '#059669' }}>Verified</span>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── COMPETITOR COMPARISON ─────────────────────────────────────────── */}
      <section style={{ background: '#FFFFFF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-5xl mx-auto">
          <FadeIn>
            <div className="text-center mb-14">
              <p className="mb-3" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2563EB' }}>Why CentricQ?</p>
              <h2 className="font-extrabold tracking-[-0.025em]" style={{ fontSize: 'clamp(28px, 4vw, 44px)', color: '#0F172A' }}>
                Everything in one place.<br />Nothing left to chance.
              </h2>
              <p className="mt-4 max-w-lg mx-auto" style={{ fontSize: 15, color: '#64748B', lineHeight: 1.65 }}>
                See how CentricQ compares to the tools most candidates use — and why piecemeal prep leaves gaps.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.08}>
            <div style={{ borderRadius: 20, overflow: 'hidden', border: '1px solid #E2E8F0', boxShadow: '0 4px 24px rgba(0,0,0,0.07)' }}>
              {/* Table header */}
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1.1fr 1fr 1fr 1fr', background: '#F8FAFC', borderBottom: '2px solid #E2E8F0' }}>
                <div style={{ padding: '16px 20px', fontSize: 12, fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Feature</div>
                {[
                  { name: 'CentricQ', highlight: true  },
                  { name: 'ChatGPT',      highlight: false },
                  { name: 'Job boards',   highlight: false },
                  { name: 'YouTube',      highlight: false },
                ].map(col => (
                  <div key={col.name} style={{ padding: '16px 12px', textAlign: 'center', background: col.highlight ? '#1B3A5C' : 'transparent' }}>
                    <span style={{ fontSize: 13, fontWeight: 800, color: col.highlight ? '#fff' : '#334155' }}>{col.name}</span>
                    {col.highlight && <div style={{ marginTop: 4, fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.5)', letterSpacing: '0.06em' }}>YOU ARE HERE</div>}
                  </div>
                ))}
              </div>

              {/* Rows */}
              {COMPARE.map((row, i) => (
                <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 1.1fr 1fr 1fr 1fr', borderBottom: i < COMPARE.length - 1 ? '1px solid #F1F5F9' : 'none', background: i % 2 === 0 ? '#FFFFFF' : '#FAFAFA' }}>
                  <div style={{ padding: '13px 20px', fontSize: 13, fontWeight: 500, color: '#334155', display: 'flex', alignItems: 'center' }}>{row.label}</div>
                  <div style={{ padding: '13px 12px', background: 'rgba(27,58,92,0.04)', display: 'flex', alignItems: 'center', justifyContent: 'center', borderLeft: '1px solid rgba(27,58,92,0.08)', borderRight: '1px solid rgba(27,58,92,0.08)' }}>
                    <CompareCell v={row.ip} />
                  </div>
                  <div style={{ padding: '13px 12px', display: 'flex', alignItems: 'center' }}><CompareCell v={row.gpt} /></div>
                  <div style={{ padding: '13px 12px', display: 'flex', alignItems: 'center' }}><CompareCell v={row.boards} /></div>
                  <div style={{ padding: '13px 12px', display: 'flex', alignItems: 'center' }}><CompareCell v={row.video} /></div>
                </div>
              ))}
            </div>

            <div className="flex justify-center gap-5 mt-6 flex-wrap">
              {[
                { icon: <span style={{ width: 14, height: 14, borderRadius: '50%', background: '#D1FAE5', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><IconCheck className="w-2 h-2" style={{ color: '#059669' }} /></span>, label: 'Fully supported' },
                { icon: <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 99, background: '#FEF3C7', color: '#D97706' }}>Partial</span>, label: 'Requires manual setup / unstructured' },
                { icon: <span style={{ width: 14, height: 14, borderRadius: '50%', background: '#FEE2E2', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><IconX className="w-2 h-2" style={{ color: '#DC2626' }} /></span>, label: 'Not available' },
              ].map(({ icon, label }) => (
                <div key={label} className="flex items-center gap-2">
                  {icon}
                  <span style={{ fontSize: 12, color: '#64748B' }}>{label}</span>
                </div>
              ))}
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── PRICING TEASER ────────────────────────────────────────────────── */}
      <section style={{ background: '#F0F6FF' }} className="py-24 px-6 lg:px-10">
        <div className="max-w-[960px] mx-auto">
          <FadeIn>
            <div className="text-center mb-14">
              <p className="mb-3" style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2563EB' }}>Pricing</p>
              <h2 className="font-extrabold tracking-[-0.025em]" style={{ fontSize: 'clamp(28px, 4vw, 44px)', color: '#0F172A' }}>Simple, transparent pricing</h2>
              <p className="mt-3" style={{ fontSize: 15, color: '#64748B' }}>Start free. Go deeper when you're ready.</p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <FadeIn delay={0}>
              <div className="border rounded-[20px] p-9 h-full flex flex-col" style={{ borderColor: '#E2E8F0', background: '#FFFFFF', boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)' }}>
                <p className="font-bold uppercase tracking-[0.1em] mb-3" style={{ fontSize: 11, color: '#64748B' }}>Free</p>
                <p className="font-extrabold leading-none mb-1" style={{ fontSize: 46, color: '#0F172A' }}>$0</p>
                <p className="mb-8" style={{ fontSize: 13, color: '#64748B' }}>No credit card needed</p>
                <div className="flex-1 mb-8 space-y-3">
                  {['100 free questions (Chapter 1)', 'MCQ practice included', 'Basic AI feedback', '1 ATS CV scan', 'No account required', 'Browse all study guides (Ch.1)'].map(f => (
                    <div key={f} className="flex gap-2.5" style={{ fontSize: 14, color: '#334155' }}>
                      <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#D1FAE5' }}><IconCheck className="w-2.5 h-2.5" style={{ color: '#059669' }} /></div>
                      {f}
                    </div>
                  ))}
                </div>
                <Link to="/roles" className="block text-center rounded-xl py-3 font-bold no-underline transition-all duration-200 border-[1.5px]"
                  style={{ borderColor: '#1B3A5C', color: '#1B3A5C', fontSize: 15 }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#1B3A5C'; e.currentTarget.style.color = '#fff'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#1B3A5C'; }}>
                  Start free
                </Link>
              </div>
            </FadeIn>

            <FadeIn delay={0.08}>
              <div className="border-2 rounded-[20px] p-9 bg-white h-full flex flex-col" style={{ borderColor: '#1B3A5C', boxShadow: '0 8px 32px rgba(27,58,92,0.10)' }}>
                <p className="font-bold uppercase tracking-[0.1em] mb-3" style={{ fontSize: 11, color: '#1B3A5C' }}>Starter</p>
                <p className="font-extrabold leading-none mb-1" style={{ fontSize: 46, color: '#0F172A' }}>${fmt(prices.starter)}</p>
                <p className="mb-8" style={{ fontSize: 13, color: '#64748B' }}>1 role + 1 study guide / month</p>
                <div className="flex-1 mb-8 space-y-3">
                  {['1,000 questions for 1 role', 'MCQ, written & spoken practice', 'Full AI feedback on every answer', 'Full access to 1 complete study guide', 'End-of-session improvement plan', 'Digital completion certificate'].map(f => (
                    <div key={f} className="flex gap-2.5" style={{ fontSize: 14, color: '#334155' }}>
                      <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#D1FAE5' }}><IconCheck className="w-2.5 h-2.5" style={{ color: '#059669' }} /></div>
                      {f}
                    </div>
                  ))}
                </div>
                <Link to="/roles" className="block text-center text-white rounded-xl py-3 font-bold no-underline transition-all duration-200"
                  style={{ background: '#1B3A5C', fontSize: 15 }}
                  onMouseEnter={e => e.currentTarget.style.background = '#142d47'}
                  onMouseLeave={e => e.currentTarget.style.background = '#1B3A5C'}>
                  Choose a role →
                </Link>
              </div>
            </FadeIn>

            <FadeIn delay={0.16}>
              <div className="border-2 rounded-[20px] p-9 bg-white relative h-full flex flex-col" style={{ borderColor: '#1B3A5C', boxShadow: '0 8px 32px rgba(27,58,92,0.12)' }}>
                <div className="absolute -top-[14px] left-1/2 -translate-x-1/2 text-white text-[11px] font-bold px-4 py-1.5 rounded-full whitespace-nowrap" style={{ background: '#C1272D' }}>Best value</div>
                <p className="font-bold uppercase tracking-[0.1em] mb-3" style={{ fontSize: 11, color: '#1B3A5C' }}>Full Access</p>
                <p className="font-extrabold leading-none mb-1" style={{ fontSize: 46, color: '#0F172A' }}>${fmt(prices.fa)}</p>
                <p className="mb-8" style={{ fontSize: 13, color: '#64748B' }}>All roles + all study guides / month</p>
                <div className="flex-1 mb-8 space-y-3">
                  {['Every role on the platform', 'Full access to all study guides', 'MCQ, written & spoken practice', 'Full AI feedback on every answer', 'End-of-session improvement plan', 'Digital completion certificate', 'Priority access to new roles'].map(f => (
                    <div key={f} className="flex gap-2.5" style={{ fontSize: 14, color: '#334155' }}>
                      <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#D1FAE5' }}><IconCheck className="w-2.5 h-2.5" style={{ color: '#059669' }} /></div>
                      {f}
                    </div>
                  ))}
                </div>
                <Link to="/subscribe/full-access" className="block text-center text-white rounded-xl py-3 font-bold no-underline transition-all duration-200"
                  style={{ background: '#C1272D', fontSize: 15 }}
                  onMouseEnter={e => e.currentTarget.style.background = '#A8202B'}
                  onMouseLeave={e => e.currentTarget.style.background = '#C1272D'}>
                  Get Full Access →
                </Link>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.2}>
            <div className="text-center mt-8">
              <Link to="/pricing" className="no-underline font-semibold transition-colors duration-200" style={{ fontSize: 14, color: '#64748B' }}
                onMouseEnter={e => e.currentTarget.style.color = '#1B3A5C'}
                onMouseLeave={e => e.currentTarget.style.color = '#64748B'}>
                View full pricing & compare plans →
              </Link>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── FINAL CTA ─────────────────────────────────────────────────────── */}
      <section className="py-24 px-6 lg:px-10" style={{ background: 'linear-gradient(135deg, #040C18 0%, #081524 40%, #1B3A5C 100%)' }}>
        <div className="max-w-[720px] mx-auto text-center">
          <FadeIn>
            <div className="inline-flex items-center gap-2 rounded-full px-4 py-2 mb-8 border" style={{ background: 'rgba(193,39,45,0.12)', borderColor: 'rgba(193,39,45,0.3)' }}>
              <span className="w-2 h-2 rounded-full animate-pulse flex-shrink-0" style={{ background: '#C1272D' }} />
              <span className="font-semibold" style={{ fontSize: 13, color: 'rgba(255,255,255,0.75)' }}>Your next interview could be in 3 days</span>
            </div>
            <h2 className="font-extrabold text-white tracking-[-0.025em] mb-5 leading-[1.1]" style={{ fontSize: 'clamp(32px, 5vw, 52px)' }}>
              Don't go into your next interview<br />
              <span style={{ color: '#C1272D' }}>unprepared.</span>
            </h2>
            <p className="leading-[1.75] mb-10" style={{ fontSize: 17, color: 'rgba(255,255,255,0.55)' }}>
              100 questions free (Chapter 1). No credit card. No account needed.<br />Just pick your role and start practising right now.
            </p>
            <div className="flex gap-4 justify-center flex-wrap">
              <Link to="/roles" className="inline-flex items-center gap-2 text-white no-underline px-8 py-4 rounded-xl font-bold transition-all duration-200"
                style={{ background: '#C1272D', fontSize: 15 }}
                onMouseEnter={e => { e.currentTarget.style.background = '#A8202B'; e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(193,39,45,0.30)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#C1272D'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                Browse all roles <IconArrow className="w-4 h-4" />
              </Link>
              <Link to="/register" className="inline-flex items-center gap-2 text-white no-underline px-8 py-4 rounded-xl font-semibold border transition-all duration-200"
                style={{ background: 'rgba(255,255,255,0.06)', borderColor: 'rgba(255,255,255,0.20)', fontSize: 15 }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.12)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.transform = 'translateY(0)'; }}>
                Create free account
              </Link>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── FOOTER ────────────────────────────────────────────────────────── */}
      <footer style={{ background: '#080f1a' }} className="px-6 lg:px-10 pt-14 pb-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row justify-between items-start gap-10 mb-10">
            <div>
              <p className="font-extrabold text-white mb-2 tracking-tight" style={{ fontSize: 20 }}>
                Centric<span style={{ color: '#C1272D' }}>Q</span>
              </p>
              <p className="max-w-[220px] leading-[1.65]" style={{ fontSize: 14, color: 'rgba(255,255,255,0.30)' }}>
                The complete AI-powered interview preparation platform.
              </p>
            </div>
            <div className="flex gap-12 flex-wrap">
              {[
                { heading: 'Product', links: [['Browse roles', '/roles'], ['Study Guides', '/courses'], ['JD Prep', '/interview-prep'], ['Pricing', '/pricing']] },
                { heading: 'Account', links: [['Sign in', '/login'], ['Create account', '/register'], ['Dashboard', '/dashboard']] },
                { heading: 'Company', links: [['About', '/about'], ['Contact', '/contact'], ['For Companies', '/company/login']] },
                { heading: 'Legal', links: [['Privacy policy', '/privacy'], ['Terms of service', '/terms']] },
              ].map(({ heading, links }) => (
                <div key={heading}>
                  <p className="font-bold uppercase tracking-[0.1em] mb-4" style={{ fontSize: 11, color: 'rgba(255,255,255,0.25)' }}>{heading}</p>
                  {links.map(([label, to]) => (
                    <Link key={label} to={to} className="block no-underline mb-2.5 transition-colors duration-200"
                      style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)' }}
                      onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.70)'}
                      onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'}>
                      {label}
                    </Link>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="border-t pt-6 flex flex-col sm:flex-row justify-between gap-3" style={{ borderColor: 'rgba(255,255,255,0.07)' }}>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.20)' }}>© {new Date().getFullYear()} CentricQ. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="no-underline transition-colors" style={{ fontSize: 13, color: 'rgba(255,255,255,0.20)' }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.20)'}>Privacy</Link>
              <Link to="/terms"   className="no-underline transition-colors" style={{ fontSize: 13, color: 'rgba(255,255,255,0.20)' }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.20)'}>Terms</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
